import { PieChart as PieIcon, BarChart3 } from 'lucide-react';
import type { DashboardCharts } from '../../lib/dashboardApi';
import { formatCurrency } from '../../lib/format';
import { DonutChart, IncomeExpenseBarChart } from './charts';

interface ChartsSectionProps {
  charts: DashboardCharts;
}

/** Revenue-by-project donut card (standalone widget). */
export function RevenueDonutCard({ charts }: ChartsSectionProps) {
  const currency = charts.currency;
  const donutData = charts.revenueByProject.map((s) => ({ name: s.projectName, value: s.amount }));

  return (
    <section className="h-full rounded-2xl border border-border bg-card p-6 shadow-card">
      <div className="flex items-center gap-2">
        <PieIcon className="h-4 w-4 text-blue-400" aria-hidden />
        <h3 className="text-sm font-semibold text-foreground">Distribuție venituri pe proiecte</h3>
      </div>
      <p className="mt-1 text-xs text-muted-foreground">An curent · pe proiect</p>
      <div className="mt-4">
        <DonutChart data={donutData} formatValue={(v) => formatCurrency(v, currency)} />
      </div>
    </section>
  );
}

/** Six-month income-vs-expenses grouped bar chart card (standalone widget). */
export function IncomeExpenseCard({ charts }: ChartsSectionProps) {
  const currency = charts.currency;

  return (
    <section className="h-full rounded-2xl border border-border bg-card p-6 shadow-card">
      <div className="flex items-center gap-2">
        <BarChart3 className="h-4 w-4 text-emerald-400" aria-hidden />
        <h3 className="text-sm font-semibold text-foreground">Venituri vs cheltuieli</h3>
      </div>
      <p className="mt-1 text-xs text-muted-foreground">Ultimele 6 luni</p>
      <div className="mt-4">
        <IncomeExpenseBarChart
          data={charts.cashflow6m}
          formatValue={(v) => formatCurrency(v, currency)}
        />
      </div>
    </section>
  );
}

/**
 * Visual charts row (CLE-257): revenue-by-project donut + a six-month
 * income-vs-expenses grouped bar chart, side by side on desktop.
 */
export function ChartsSection({ charts }: ChartsSectionProps) {
  return (
    <div className="grid gap-4 lg:grid-cols-2">
      <RevenueDonutCard charts={charts} />
      <IncomeExpenseCard charts={charts} />
    </div>
  );
}
